import { makeStyles } from "@material-ui/core";

const makeClasses = makeStyles((theme) => ({
  borderedCheckboxContainer: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    border: `1px solid #D1D5DE`,
    borderRadius: "10px",
    padding: "0.938rem",
  },
  checkbox: {
    color: `#D1D5DE`,
  },
  checkboxLabel: {
    fontSize: "1rem",
  },
  checkboxSubtitle: {
    fontSize: "0.875rem",
    color: "#6A7282",
  },
}));

export default makeClasses;
